import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import { getToken } from '../utils/storage'
import Layout from '../views/Layout/index.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/Index.vue'),
        meta: { title: '数据大盘' }
      },
      // 系统管理
      {
        path: 'system/admin',
        name: 'AdminList',
        component: () => import('../views/system/AdminList.vue'),
        meta: { title: '后台账号管理' }
      },
      {
        path: 'system/config',
        name: 'SysConfig',
        component: () => import('../views/system/SysConfig.vue'),
        meta: { title: '系统参数配置' }
      },
      {
        path: 'system/log',
        name: 'OpLog',
        component: () => import('../views/system/OpLog.vue'),
        meta: { title: '操作日志' }
      },
      // 业主商户
      {
        path: 'owner/list',
        name: 'OwnerList',
        component: () => import('../views/owner/OwnerList.vue'),
        meta: { title: '业主&支付子商户' }
      },
      // 广告
      {
        path: 'banner/list',
        name: 'BannerList',
        component: () => import('../views/banner/BannerList.vue'),
        meta: { title: '轮播广告管理' }
      },
      // 房源房间
      {
        path: 'house/list',
        name: 'HouseList',
        component: () => import('../views/house/HouseList.vue'),
        meta: { title: '房源管理' }
      },
      {
        path: 'room/list',
        name: 'RoomList',
        component: () => import('../views/room/RoomList.vue'),
        meta: { title: '房间管理/审核' }
      },
      // 合同账单
      {
        path: 'contract/list',
        name: 'ContractList',
        component: () => import('../views/contract/ContractList.vue'),
        meta: { title: '全部租赁合同' }
      },
      {
        path: 'bill/list',
        name: 'BillList',
        component: () => import('../views/bill/BillList.vue'),
        meta: { title: '账单审核与导出' }
      },
      // 小程序用户
      {
        path: 'wxuser/list',
        name: 'WxUserList',
        component: () => import('../views/wxuser/WxUserList.vue'),
        meta: { title: '小程序租客用户' }
      },
      // 报修工单
      {
        path: 'repair/list',
        name: 'RepairList',
        component: () => import('../views/repair/RepairList.vue'),
        meta: { title: '全部报修工单' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
